import { Card, CardActions, CardContent, CardHeader } from "@mui/material";
import { createStyles, withStyles, WithStyles } from "@mui/styles";
import * as api from "api/Core";
import ButtonPrint from "components/Buttons/ButtonPrint";
import { RequestIndicator } from "components/CallServer";
import MuiMessageBox from "components/MuiExtras/MessageBox/MuiMessageBox";
import MuiPushRight from "components/MuiExtras/MuiPushRight";
import HtmlUtils from "lib/HtmlUtils";
import { PublicationShortView } from "models/ApiModels";
import * as QRCode from "qrcode.react";
import * as React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import { RouteComponentProps } from "react-router";

/////////////////////////////////////////////////////////////////////////////////////

interface IState {
    loading: boolean;
    data: PublicationShortView;
}

interface IProps {
}

interface IRouteParams {
    id: string;
}

const styles = createStyles({
    hidePrint: {
    },

    "@media print": {
        hidePrint: {
            display: "none"
        }
    }
});

type Props = IProps & RouteComponentProps<IRouteParams> & WithStyles<typeof styles> & WithTranslation;

/////////////////////////////////////////////////////////////////////////////////////

class PublicationQrCode extends React.PureComponent<Props, IState> {

    constructor(props: Props) {
        super(props);
        this.state = {
            data: null,
            loading: true,
        };
    }

    private load() {
        return api.getPublicationShortView(this.props.match.params.id)
            .then((data) => {
                this.setState({ data, loading: false });
            })
            .catch(() => {
                this.setState({ loading: false });
            });
    }

    public componentDidMount() {
        this.load();
    }

    public render() {
        const { data, loading } = this.state;

        if (loading)
            return <RequestIndicator type="request" />;

        if (!loading && data == null)
            return <MuiMessageBox variant="error" message={this.props.t("Views.Publication.PublicationQrCode.LoadError")} />;

        const {
            title,
            viewUrl
        } = this.state.data;

        return (
            <Card>
                <CardHeader title={title} />
                <CardContent>
                    <div style={{ textAlign: "center" }}>
                        <QRCode value={HtmlUtils.getFullUrl(viewUrl)} size={384} />
                    </div>
                </CardContent>
                <CardActions className={this.props.classes.hidePrint}>
                    <MuiPushRight>
                        <ButtonPrint
                            onClick={() => { window.print(); }}
                        />
                    </MuiPushRight>
                </CardActions>
            </Card>
        );
    }
}

export default withTranslation()(withStyles(styles)(PublicationQrCode));
